// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".countdown[data-v-d5d4ccb2] {\n  margin: calc(var(--magic-space, 16px) + var(--magic-space--small, 8px)) auto;\n}\n\n.text[data-v-d5d4ccb2] {\n  font-weight: 900;\n}\n.text--digit[data-v-d5d4ccb2] {\n  color: var(--magic-primary, #0c66ff);\n}", ""]);
// Exports
module.exports = exports;
